export const vacancyTranslations = {
  lv: {
    title: 'Manas vakances',
    attraction: 'Piesaiste',
    count: '{{count}} vakances',
    count_one: '{{count}} vakance',
    count_other: '{{count}} vakances',
    count_zero: '{{count}} vakanču',
    description:
      'Vakances redz tie studenti, kuru prakses profesija atbilst vakances kategorijai. Prakses vietas kontā visas vakances ir zem viena profila.',
    how: 'Kā vakances strādā',
    collapse: 'Sakļaut',
    steps: '4 soļi',
    step1: 'Izveidojat vakanci',
    body1: 'Norādāt profesijas kategoriju — tā izšķir, kuri studenti vakanci vispār ieraudzīs.',
    step2: 'Studenti to redz',
    body2:
      'Students, kura prakses programma atbilst šai kategorijai, redz vakanču sarakstu. Tajā ir arī jūsu.',
    step3: 'Students piesakās',
    body3:
      'Pieteikumā ir motivācija, prakses periods un izglītības iestāde. Viņš var pieteikties vairākām vietām.',
    step4: 'Jūs apstiprināt',
    body4: 'Kurš apstiprina pirmais — tas dabū praktikantu. Pārējie pieteikumi atkrīt automātiski.',
    search: 'Meklēt vakanci…',
    filters: 'Filtri',
    create: 'Izveidot bezmaksas vakanci',
    edit: 'Rediģēt vakanci',
    delete: 'Dzēst vakanci',
    activate: 'Publicēt',
    deactivate: 'Deaktivizēt',
    published: 'Publicēta',
    inactive: 'Neaktīva',
    showAll: 'Rādīt visu',
    showLess: 'Rādīt mazāk',
    empty: 'Vakances nav atrastas',
    emptyBody: 'Publicējiet vakanci, lai studenti jūs atrastu, vai mainiet meklēšanas nosacījumus.',
    loadError: 'Neizdevās ielādēt vakances',
    error: 'Darbība neizdevās. Mēģiniet vēlreiz.',
    saved: 'Vakance saglabāta',
    actions: 'Vakances darbības',
    clear: 'Notīrīt',
    apply: 'Filtrēt',
    save: 'Saglabāt',
    required: 'Aizpildiet obligātos laukus.',
    deleteConfirm: 'Vai dzēst vakanci “{{title}}”?',
    metricsUnavailable:
      'Vakanču skatījumu un pieteikumu skaits pašlaik nav pieejams. Pieteikumus skatiet sadaļā “Prakses pieteikumi”.',
    applications: 'Prakses pieteikumi',
    OnSite: 'Klātienē',
    Mixed: 'Klātienē un attālināti',
    Remote: 'Attālināti',
    Dynamic: 'Mainīga prakses vieta',
    NotSet: 'Nav norādīts',
    fields: {
      end: 'Aktuāla līdz',
      title: 'Vakances nosaukums',
      description: 'Apraksts',
      categories: 'Kategorija',
      places: 'Brīvās vietas',
      workplace: 'Prakses veids',
      countryId: 'Valsts',
      address: 'Prakses vietas adrese',
      orgName: 'Prakses vietas nosaukums',
      orgRegNo: 'Reģistrācijas numurs',
      orgLegalAddress: 'Juridiskā adrese',
      signatory: 'Paraksttiesīgā persona',
    },
    columns: {
      title: 'Vakance',
      categories: 'Kategorija',
      places: 'Vietas',
      workplace: 'Prakses veids',
      views: 'Skatījumi',
      applications: 'Pieteikumi',
      active: 'Statuss',
    },
  },
  en: {
    title: 'My vacancies',
    attraction: 'Recruitment',
    count: '{{count}} vacancies',
    count_one: '{{count}} vacancy',
    count_other: '{{count}} vacancies',
    description:
      'Students see vacancies that match their internship profession. All company vacancies appear under one profile.',
    how: 'How vacancies work',
    collapse: 'Collapse',
    steps: '4 steps',
    step1: 'Create a vacancy',
    body1: 'Choose a profession category — it determines which students can see the vacancy.',
    step2: 'Students see it',
    body2:
      'Students whose internship program matches the category see the vacancy list, including yours.',
    step3: 'Students apply',
    body3:
      'Applications include motivation, internship dates and the educational institution. Students can apply to several placements.',
    step4: 'You confirm',
    body4:
      'The first provider to confirm gets the intern. Other applications are withdrawn automatically.',
    search: 'Search vacancies…',
    filters: 'Filters',
    create: 'Create a free vacancy',
    edit: 'Edit vacancy',
    delete: 'Delete vacancy',
    activate: 'Publish',
    deactivate: 'Deactivate',
    published: 'Published',
    inactive: 'Inactive',
    showAll: 'Show all',
    showLess: 'Show less',
    empty: 'No vacancies found',
    emptyBody: 'Publish a vacancy so students can find you, or change your search criteria.',
    loadError: 'Could not load vacancies',
    error: 'The action failed. Please try again.',
    saved: 'Vacancy saved',
    actions: 'Vacancy actions',
    clear: 'Clear',
    apply: 'Apply filters',
    save: 'Save',
    required: 'Complete the required fields.',
    deleteConfirm: 'Delete vacancy “{{title}}”?',
    metricsUnavailable:
      'Vacancy view and application counts are currently unavailable. See applications on the Applications page.',
    applications: 'Applications',
    OnSite: 'On site',
    Mixed: 'On site and remote',
    Remote: 'Remote',
    Dynamic: 'Variable workplace',
    NotSet: 'Not specified',
    fields: {
      end: 'Valid until',
      title: 'Vacancy title',
      description: 'Description',
      categories: 'Category',
      places: 'Available places',
      workplace: 'Internship type',
      countryId: 'Country',
      address: 'Workplace address',
      orgName: 'Organization name',
      orgRegNo: 'Registration number',
      orgLegalAddress: 'Legal address',
      signatory: 'Signatory',
    },
    columns: {
      title: 'Vacancy',
      categories: 'Category',
      places: 'Places',
      workplace: 'Internship type',
      views: 'Views',
      applications: 'Applications',
      active: 'Status',
    },
  },
}
